import { motion } from "framer-motion";
import { STATS } from "../lib/content";

export default function Stats() {
  return (
    <section className="bg-[#0A1F3F] text-white py-20" data-testid="stats-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-[#1E3966]">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="px-6 py-10 lg:py-0 first:pl-0 lg:pl-12 first:pt-0"
              data-testid={`stat-${i}`}
            >
              <div className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-[#F37021]">
                {s.value}
              </div>
              <div className="mt-3 text-eyebrow text-white/70">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
